import { setLanguage } from "config/language";
import Banner from "../common/Banner";
import { useEffect, useState } from "react";
import BazAIHelmet from "../common/BazAIHelmet";
import { baseUrl } from "config/apiUrl";
import { healthPageData, healthFAQs } from "./healthFacilites";
import UpdateNavbar from "pages/UpdatedLanding/Common/UpdateNavbar";
import UpdateFooter from "pages/UpdatedLanding/Common/UpdateFooter";
import EnhancedPageLayout from "pages/UpdatedLanding/Common/EnhancedPageLayout";

export default function LandingForHealth() {
  const [scrollTop, setScrollTop] = useState(0);
  useEffect(() => {
    function onScroll() {
      setScrollTop(document.documentElement.scrollTop);
    }
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [scrollTop]);
  if (localStorage.getItem("lan") === null) {
    setLanguage();
  }

  return (
    <>
      <BazAIHelmet
        title="AI-Powered Procurement for Healthcare"
        description="EkkBaz AI automates healthcare procurement — reducing manual work by 80%, cutting costs by 25%, and ensuring 99%+ supplier compliance. Prevent stockouts, manage supplier risk, and stay compliant automatically."
        keywords="healthcare procurement software, medical supply chain AI, hospital procurement automation, healthcare supplier management, pharmaceutical procurement, AI procurement healthcare"
        image="/assets/images/LogoAI.png"
        url={`${baseUrl.webUrl}/industry/healthcare`}
        industryName="Healthcare"
        faqItems={healthFAQs}
      />
      <UpdateNavbar />
      <Banner
        headline="Healthcare"
        subtitle="Automate procurement, eliminate critical stockouts, and achieve 99%+ supplier compliance — purpose-built for healthcare organisations."
        from="health"
      />
      <EnhancedPageLayout {...healthPageData} />
      <UpdateFooter />
    </>
  );
}
